import React from 'react'
import { Box, Typography, useTheme, Select, Chip, MenuItem, CssBaseline,Modal,CircularProgress, ThemeProvider, Grid, TextField, Button,IconButton } from "@mui/material";
import { tokens } from "../theme";
import { useState, useEffect, useRef } from "react";
import { Topbar } from '../layouts/Topbar';
import Sidebarr from '../layouts/Sidebar';
import Header from "../components/Header";
import {api} from "../api";
import { fetchToken } from '../auth/Token';
import { decode } from 'base-64';
import Divider from '@mui/material/Divider';
import Avatar from '@mui/material/Avatar';
import Snackbar from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useLocation, useNavigate } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import { toast } from 'sonner';



export const UserProfile = () => {
    const [personaInfo, setPersonaInfo] = useState([]);
    const [detailsInfo, setDetailsInfo] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const readypersonaInfo = location.state && location.state.personaInfo;
    const readydetailsInfo = location.state && location.state.detailsInfo;
    // USERPIC
    const [userPic, setUserPic] = useState([]);
    const [userPicRaw, setUserPicRaw] = useState([]);
    const [user_name, setUser_name] = useState(readypersonaInfo.username)
    const [new_password, setNew_password] = useState('')
    const [loading, setLoading] = useState(false)
    const form = useRef();

    const formik = useFormik({
      initialValues: {
        dob: `${readydetailsInfo.dob}`,
        gender: `${readydetailsInfo.gender}`,
        address: `${readydetailsInfo.address}`,
        phone: `${readydetailsInfo.phone}`,
        firstName: `${readypersonaInfo.firstName}`,
        middleName: `${readypersonaInfo.middleName}`,
        lastName: `${readypersonaInfo.lastName}`,
        email: `${readypersonaInfo.email}`,
        username: `${readypersonaInfo.username}`,
        account_name: `${readydetailsInfo.account_name}`,
        account_number: `${readydetailsInfo.account_number?readydetailsInfo.account_number:0}`,
        bank_name: `${readydetailsInfo.bank_name}`,
        basic_salary: `${readydetailsInfo.basic_salary?readydetailsInfo.basic_salary:0}`,
        marital_status: `${readydetailsInfo.marital_status}`,
        sinn_number: `${readydetailsInfo.sinn_number?readydetailsInfo.sinn_number:0}`,
      },
      validationSchema: Yup.object({
        dob: Yup.date(),
        firstName: Yup.string()
          .required('First name is required'),
        lastName: Yup.string()
          .required('Last name is required'),
        email: Yup.string()
          .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, 'Invalid Email format eg:example@example.com')
          .required('Email is required')
      }),
      onSubmit: (values) => {
        const newData = new FormData();
        newData.append('dob',values.dob)
        newData.append('gender',values.gender)
        newData.append('address',values.address)
        newData.append('phone',values.phone)
        newData.append('firstName',values.firstName)
        newData.append('middleName',values.middleName)
        newData.append('lastName',values.lastName)
        newData.append('email',values.email)
        newData.append('username',values.username)
        newData.append('sinn_number',values.sinn_number)
        newData.append('marital_status',values.marital_status)
        newData.append('basic_salary',values.basic_salary)
        newData.append('bank_name',values.bank_name)
        newData.append('account_name',values.account_name)
        newData.append('account_number',values.account_number)

        api.post('/users/userinfo',newData,{
          headers: {
              Authorization: 'Bearer '+ fetchToken()
          }
        }).then(function (response){
            toast.success(response.data);
            fetchUserDetailAll()
            navigate('/dashboard',{state:{go:"Go"}})
        }).catch(function (error){
          console.log(error)
        })
      }
    });
  





    const fetchPersona = () => {
      api.get('/users/su',{
          headers: {
              Authorization: 'Bearer '+ fetchToken()
          }
        }).then(function (response){
          setPersonaInfo(response.data)
        }).catch(function (error){
          console.log(error)
        })
    }

    useEffect(() => {
      fetchPersona()
    }, [])
    
// USERPIC
      const handleNewFile = (e) => {
        const userPicture = new FormData();
        userPicture.append('userImage', e.target.files[0])
        api.post('/users/picture/update',userPicture,{
          headers: {
              Authorization: 'Bearer '+ fetchToken()
          }
        }).then(function (response){
            toast.success(response.data);
            fetchUserPic()
        }).catch(function (error){
          console.log(error)
        })
      }

      const fetchUserPic = () => {
          api.get('/users/details',{
            headers: {
                Authorization: 'Bearer '+ fetchToken()
            }
          }).then(function (response){
            setUserPicRaw(response.data)
            const userPhoto = response.data
            const decodedImage = decode(userPhoto);
            setUserPic(decodedImage)
          }).catch(function (error){
            console.log(error)
          })
      }
    
    React.useEffect(() => {
      fetchUserPic()
    }, [])

    const fetchUserDetailAll = () =>{
      api.get('/users/details/all',{
          headers: {
              Authorization: 'Bearer '+ fetchToken()
          }
        }).then(function (response){
            setDetailsInfo(response.data?.details);
        }).catch(function (error){
          console.log(error)
        })
    }

    React.useEffect(() => {
      fetchUserDetailAll()
    }, [])

    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
      setIsHovered(true);
    };

    const handleMouseLeave = () => {
      setIsHovered(false);
    };

    // React.useEffect(() => {
    //   if (detailsInfo && personaInfo) {
    //     const initialFormValues = {
          
    //     }
    //   }
    // }, [detailsInfo, personaInfo]);
        
      

    const genderChip = () =>{
      if (detailsInfo.gender === 'male' || 'Male'){
        return(
          <Chip label='Male' sx={{ backgroundColor: '#3a0ca3', color:'#fff' }}/>
        )
      }else{
        return(
          <Chip label='Female' sx={{ backgroundColor: '#ea9ab2', color:'#000' }}/>
        )
      }
    }

    // console.log(formik.values.email);
    const [sjh, ruth] = useState(false)

    const hanjjj = () =>{
      // e.preventDefault()
      ruth(true)

    // emailjs.sendForm('service_c9e4iwy', 'template_q276hox', form.current, 'YAjx2GfxZbn5kGmul')
    // .then((result) => {
    //     console.log(result.text, "Done");
    // }, (error) => {
    //     console.log(error.text);
    // });
};
    



    const handleClosee = () =>{
      ruth(false)
      setUser_name('')
      setNew_password('')
    }

    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 520,
      maxHeight: '50vh', 
      overflowY: 'auto', 
      bgcolor: 'background.paper',
      border: '1px solid #e7ecef',
      borderRadius: '7px',
      boxShadow: 24,
      p: 4,
    };

    const handleChangePassword = () => {
      setLoading(true)
      const info = {
        'username': user_name,
        'new_password': new_password
      }
      api.put('/users/password',info,{
        headers: {
          Authorization: 'Bearer '+fetchToken()
        }
      }).then(function (response){
        toast.success(response.data);
        handleClosee()
      }).catch(function (error){
        console.log(error)
      }).finally(function (){
        setLoading(false)
      })
    }

    

  return (
      <div className="app">
        <main className="content">
            <Box sx={{ m:5 }}>
              {/* HEADER */}
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Header title="Profile" subtitle="Welcome to your Profile Page" />
              </Box>

              <Box>
                <Grid container spacing={1} sx={{ minHeight:690, paddingBottom:5, paddingTop:3 }}>
                  {/* Pic ,Name and Email  */}
                  <Grid item xs={12} md={4} sx={{ borderRight: 'groove 1px black', textAlign:'center'}}>
                    <input
                      accept="image/*"
                      id="contained-button-file"
                      hidden
                      name='userPicture'
                      onChange={handleNewFile}
                      type="file"
                    />
                    <label htmlFor="contained-button-file">
                    <IconButton
                      component='span'
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                      sx={{ position: 'relative' }}>
                      <Avatar
                        alt="User Pic"
                        src={userPicRaw ? `data:image/jpeg;base64,${btoa(userPic)}` : "data:image/png;base64,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"}
                        sx={{
                          width: 286,
                          height: 286,
                          margin: '0 auto',
                          filter: isHovered ? 'blur(2px)' : 'none',
                        }}
                      />
                      {isHovered && (
                          <label htmlFor="contained-button-file">
                            <IconButton component='span' sx={{fontWeight:700 ,position: 'absolute', bottom: 110, left: 0, right: 0 }}>
                              Change Profile Photo
                            </IconButton>
                          </label>
                        )}                      
                    </IconButton>
                    </label>
                      {/* name */}
                      <Typography
                        sx={{ marginTop:2, fontWeight:600 }}
                      >
                        {`${personaInfo.firstName} ${personaInfo.middleName} ${personaInfo.lastName}`}
                      </Typography>
                        {/* email */}
                      <Typography
                        sx={{ marginTop:1, fontWeight:400, color:'grey' }}
                      >
                        {personaInfo.email}
                      </Typography>
                      {genderChip()}
                        <Box sx={{ m:5 }}>
                          {/* <form ref={form} onSubmit={hanjjj}>
                            <input value={personaInfo.email} name='user_email' hidden/>
                            <input value={`${personaInfo.firstName} ${personaInfo.middleName} ${personaInfo.lastName}`} name='to_name' hidden/> */}
                      {
                        personaInfo?.role_name === 'Administrator'
                        ?
                      <Button
                        size='small'
                        variant='contained'
                        sx={{ backgroundColor:'#9d0208', color:'#fff', borderRadius:5 }}
                        // type='submit'
                        onClick={hanjjj}
                      >
                        Change Password
                      </Button>
                      : null

                      }
                      {/* </form> */}
                      </Box>
                        <Modal
                          open={sjh}
                          onClose={handleClosee}
                          // disableScrollLock = 'true'
                          aria-labelledby="modal-modal-title"
                          aria-describedby="modal-modal-description"
                        >
                      <Box sx={style}>
                        <Typography variant='h4'>Change Password</Typography>
                      {/* <div style={{ display: 'block' }}> */}
                        <TextField
                          size='small'
                          name='user_name'
                          label='User Name'
                          value={user_name}
                          onChange={e => setUser_name(e.target.value)}
                          type='text'
                          variant='outlined'
                          sx={{ m:1, borderRadius:5 }}
                        />

                        <TextField
                          size='small'
                          name='new_password'
                          label="New Password"
                          value={new_password}
                          onChange={e => setNew_password(e.target.value)}
                          type='password'
                          variant='outlined'
                          sx={{ m:1, borderRadius:5 }}
                        />

                        <div stlye={{ display: 'flex' }}>
                        <Button
                            size='small'
                            onClick={handleClosee}
                            color='error'
                            variant='contained'
                            sx={{ mt:1, mr:1 }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant='contained'
                            onClick={handleChangePassword}
                            color='success'
                            size='small'
                            sx={{ mt:1 }}
                        >
                            {
                                loading === true ?
                                <Box sx={{ width: '100%' }}>
                                    <CircularProgress />
                                </Box>
                                : "Change"
                            }
                        </Button>
                        </div>


                        {/* <TextField
                          size='small'
                          name='confirm_new_password'
                          value={new_password}
                          onChange={e => setNew_password(e.target.value)}
                          type='password'
                          variant='outlined'
                        /> */}
                        {/* </div> */}
                      </Box>
                      </Modal>
                  </Grid>

                  {/* All details in fields (editable) */}
                  <Grid item xs={12} md={6} sx={{ marginLeft: 5 }}>
                      <form onSubmit={formik.handleSubmit}>
                        <Typography variant='h4' sx={{ fontWeigth:700 }}>Personal Details</Typography>
                        <Grid container spacing={1}>
                          <Grid item xs={12} md={4}>
                            <TextField
                              helperText='First Name'
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              defaultValue={formik.values.firstName}
                              error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                              variant='standard'
                              type='text'
                              name='firstName'
                            />
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <TextField
                              helperText='Middle Name'
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              defaultValue={formik.values.middleName}
                              variant='standard'
                              type='text'
                              name='middleName'
                            />
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <TextField
                              helperText='Last Name'
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              defaultValue={formik.values.lastName}
                              error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                              variant='standard'
                              type='text'
                              name='lastName'
                            />
                          </Grid>

                          <Grid item xs={12} md={8}>
                            <TextField
                              helperText='User Name'
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              defaultValue={formik.values.username}
                              variant='standard'
                              type='text'
                              name='username'
                              fullWidth
                            />
                          </Grid>

                          <Grid item xs={12} md={4}>
                            <Select
                              helperText='Gender'
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              defaultValue={formik.values.gender}
                              variant='standard'
                              name='gender'
                              fullWidth
                            >
                              <MenuItem value='Male'>Male</MenuItem>
                              <MenuItem value='Female'>Female</MenuItem>
                            </Select>
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <TextField
                              helperText='Email'
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              defaultValue={formik.values.email}
                              error={formik.touched.email && Boolean(formik.errors.email)}
                              variant='standard'
                              name='email'
                              type='email'
                              fullWidth
                            />
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <TextField
                              helperText='Role'
                              value={personaInfo?.role_name}
                              variant='standard'
                              name='role'
                              fullWidth
                              disabled
                            />
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <TextField
                              helperText='Contact Phone'
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              defaultValue={formik.values.phone}
                              variant='standard'
                              name='phone'
                              fullWidth
                            />
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <TextField
                              helperText='Address'
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              defaultValue={formik.values.address}
                              variant='standard'
                              name='address'
                              fullWidth
                              type='text'
                            />
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <TextField
                              helperText='Date of Birth'
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              defaultValue={formik.values.dob}
                              error={formik.touched.dob && Boolean(formik.errors.dob)}
                              variant='standard'
                              name='dob'
                              type='date'
                              fullWidth
                            />
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <TextField
                              helperText='Marital Status'
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              defaultValue={formik.values.marital_status}
                              error={formik.touched.dob && Boolean(formik.errors.marital_status)}
                              variant='standard'
                              name='marital_status'
                              type='text'
                              fullWidth
                            />
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <TextField
                              helperText='Basic Salary(GHS)'
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              defaultValue={formik.values.basic_salary}
                              error={formik.touched.dob && Boolean(formik.errors.basic_salary)}
                              variant='standard'
                              name='basic_salary'
                              type='number'
                              disabled
                              fullWidth
                            />
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <TextField
                              helperText='Account Name'
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              defaultValue={formik.values.account_name}
                              error={formik.touched.dob && Boolean(formik.errors.account_name)}
                              variant='standard'
                              name='account_name'
                              type='text'
                              fullWidth
                            />
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <TextField
                              helperText='Account Number'
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              defaultValue={formik.values.account_number}
                              error={formik.touched.dob && Boolean(formik.errors.account_number)}
                              variant='standard'
                              name='account_number'
                              type='number'
                              fullWidth
                            />
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <TextField
                              helperText='Bank Name'
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              defaultValue={formik.values.bank_name}
                              error={formik.touched.dob && Boolean(formik.errors.bank_name)}
                              variant='standard'
                              name='bank_name'
                              type='text'
                              fullWidth
                            />
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <TextField
                              helperText='SSNIT Number'
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              defaultValue={formik.values.sinn_number}
                              error={formik.touched.dob && Boolean(formik.errors.sinn_number)}
                              variant='standard'
                              name='sinn_number'
                              type='number'
                              fullWidth
                            />
                          </Grid>


                          <Button variant='contained' onClick={() => formik.handleReset()} sx={{ backgroundColor:'#bc6c25', color:'#fff', margin:2 }}>Cancel</Button>
                          <Button variant='contained' type='submit' sx={{ backgroundColor:'#9e2a2b', color:'#fff', margin:2 }}>Save Update</Button>

                        </Grid>
                      </form>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </main>
            </div>
  )
}
